import { LeagueModel } from "@/models/LeagueModels";
import { LeaguesRepo } from "@/repos/LeaguesRepo";

// src/services/LeagueService.ts
export class LeagueService {
    constructor(private leaguesRepo: LeaguesRepo) { }

    async get(id: string): Promise<LeagueModel | null> {
        const rv = await this.leaguesRepo.getById(id);

        // hack: fill in pinPrize id values if not set
        if (rv && rv.schedule) {
            let needToSave = false;
            rv.schedule.forEach(schedule => {
                schedule.pinPrizes?.forEach(prize => {
                    if (!prize.id) {
                        prize.id = crypto.randomUUID();
                        needToSave = true;
                    }
                });
            });

            if (needToSave) {
                await this.leaguesRepo.update(id, { schedule: rv.schedule });
            }
        }

        return rv;

    }

    async create(item: LeagueModel): Promise<void> {
        return await this.leaguesRepo.create(item, item.id);
    }

    async update(id: string, updates: Partial<LeagueModel>): Promise<void> {
        return await this.leaguesRepo.update(id, updates);
    }

    async delete(id: string): Promise<void> {
        return await this.leaguesRepo.delete(id);
    }
}